__webpack_require__.p = "/static/it-IT/infografiche/eni-for-2022/";